export enum EHomeCategoryTab {
  MEN = 'men',
  WOMEN = 'women',
  NEW = 'san-pham-moi',
  BEST_SELLER = 'ban-chay-nhat',
  GOOD_PRICE = 'gia-tot-nhat',
}

const categoryTabs = [
  { key: EHomeCategoryTab.MEN, name: 'male' },
  { key: EHomeCategoryTab.WOMEN, name: 'female' },
]

const productTabs = [
  { key: EHomeCategoryTab.NEW, name: 'new' },
  { key: EHomeCategoryTab.BEST_SELLER, name: 'best_seller' },
  // { key: EHomeCategoryTab.GOOD_PRICE, name: 'Giá tốt nhất' },
]

export const HomePageConstants = {
  categoryTabs,
  productTabs,
}
